module.exports = __webpack_public_path__ + "img/icon-hide-group.fce81a67.svg";